module.exports = __webpack_public_path__ + "static/media/doctors.d4612cc3.gif";